import clsx from 'clsx';
import React from 'react';
import { ButtonStyle } from './Component.style';

function Button({
  label,
  customStyles,
  onClick,
  disabled,
  home,
  loading,
  loadingIndicator,
  type,
  ...props
}) {
  return (
    <ButtonStyle
      onClick={onClick}
      variant={type || 'contained'}
      disabled={
        (loading
          ? true
          : home
          ? disabled
          : disabled !== undefined
          ? disabled
          : false) || disabled
      }
      className={clsx(`${customStyles} ${disabled && 'disabledbtn'}`)}
      {...props}
    >
      {loading && loadingIndicator ? loadingIndicator : label}
    </ButtonStyle>
  );
}

export default Button;
